/** Entrega um arquivo ja gerado pela API ao navegador (link temporario). O front nao gera nem altera o conteudo. */
export function salvarBlob(blob: Blob, nome: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nome;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
